import React from 'react';
import { TargetIcon, ZapIcon, TrendingUpIcon } from 'lucide-react';
import { Reveal } from './Reveal';
const PILLARS = [{
  icon: TargetIcon,
  title: 'Message that lands',
  body: 'We interview your top clients to craft positioning and marketing messages that speak directly to the buyers who fund your growth.'
}, {
  icon: ZapIcon,
  title: 'Systems that scale',
  body: 'Automated marketing systems streamline your outreach — saving your team time while keeping a full, predictable pipeline.'
}, {
  icon: TrendingUpIcon,
  title: 'Sales that convert',
  body: 'We drive new prospects to sales assets engineered to convert them into high-paying, long-term clients.'
}];
export function Approach() {
  return <section id="approach" className="w-full bg-cream py-24 lg:py-32" data-id="element-25" data-mp="14516aamn2ba7">
      <div className="mx-auto max-w-container px-6 lg:px-8" data-id="element-26" data-mp="3tt1rupicbrgw">
        <Reveal className="max-w-2xl" data-id="element-27" data-mp="3otff0h6fcd8m">
          <span className="text-xs font-semibold uppercase tracking-[0.2em] text-gold-600" data-id="element-28" data-mp="3ose184y0xcn7">
            The approach
          </span>
          <h2 className="mt-4 font-display text-3xl font-semibold leading-tight tracking-tight text-ink-950 lg:text-5xl" data-id="element-29" data-mp="2qs93gdgctnla">
            A single, integrated engine for growth.
          </h2>
          <p className="mt-5 text-lg leading-relaxed text-ink-900/70" data-id="element-30" data-mp="2gy0dnxipk8qt">
            Most education businesses lose momentum in the gaps between marketing
            and sales. We close them — building one system where message, demand,
            and conversion reinforce each other.
          </p>
        </Reveal>

        <div className="mt-16 grid gap-6 md:grid-cols-3" data-id="element-31" data-mp="2byno350gcnkj">
          {PILLARS.map((pillar, i) => <Reveal key={pillar.title} delay={i * 0.1} data-id="element-32" data-mp="234isk8adinyo" data-mpi={i}>
              <div className="h-full rounded-2xl border border-ink-950/10 bg-white p-8 transition-shadow hover:shadow-lg hover:shadow-ink-950/5" data-id="element-33" data-mp="235amzfs8ifnd">
                <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-ink-950 text-gold-400" data-id="element-34" data-mp="1t6bo2ox9tydk">
                  <pillar.icon className="h-6 w-6" data-id="element-35" data-mp="1a289jhig5pke" />
                </span>
                <h3 className="mt-6 font-display text-xl font-semibold text-ink-950" data-id="element-36" data-mp="1a3j9t7coof6r">
                  {pillar.title}
                </h3>
                <p className="mt-3 text-[15px] leading-relaxed text-ink-900/70" data-id="element-37" data-mp="10cyh20joy4vr">
                  {pillar.body}
                </p>
              </div>
            </Reveal>)}
        </div>
      </div>
    </section>;
}